export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto bg-background-50 rounded-2xl p-8 md:p-10 text-center">
          <div className="w-14 h-14 mx-auto rounded-2xl bg-primary-100/80 flex items-center justify-center mb-5">
            <i className="ri-mail-send-line text-primary-500 text-2xl" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm text-foreground-500 leading-relaxed mb-6">
            如有版权问题、内容合作、广告投放或使用建议，欢迎通过以下方式联系番茄影视团队。我们重视每一条反馈，期待与您共建优质影视平台。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-mail-line text-primary-500" />
              <span>contact@fanqieys.com</span>
            </div>
            <div className="hidden sm:block w-px h-5 bg-background-300" />
            <div className="flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-chat-3-line text-primary-500" />
              <span>在线反馈通道即将开放</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}